import { Injectable } from '@angular/core';
import { CachingApiService } from './cachingApiService';
import { OpsRegion } from '.';
import { SessionStorageService } from '../storage/session-storage.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { Observable, of, switchMap } from 'rxjs';
import { LinkableLocationsService, LocationGroup } from './linkable-locations.service';
import { BroadcastService } from '../services/broadcast.service';

@Injectable({
  providedIn: 'root'
})
export class OpsRegionService extends CachingApiService<OpsRegion[]> {
  protected broadcastKey: string = "ops-regions"
  override getApiUrl(): string {
    return `${this.config.dataApiUrl}/ops-regions`
  }

  constructor(
    http: HttpClient,
    config: ConfigService,
    storage: SessionStorageService,
    private locationService: LinkableLocationsService,
    broadcastService: BroadcastService
  ) {
    super(http, config, storage, broadcastService)
  }


  getOpsRegions(): Observable<OpsRegion[]> {
    return this.getCache().pipe(switchMap(cache => of([...cache.data])))
  }

  getOpsRegionById(id: number): Observable<OpsRegion | undefined> {
    return this.getCache().pipe(switchMap(cache => of(cache.data.find(r => r.id === id))))
  }

  getOpsRegionLocationGroups(): Observable<LocationGroup[]> {
    return this.getCache().pipe(
      switchMap(cache => this.locationService.getLocations("active").pipe(
        switchMap(
          locations => of(cache.data.map(r => ({ label: r.name, locations: locations.filter(l => l.opsRegionId === r.id) }))
          ))
      ))
    )
  }
}
